import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import api from "../../storage/api";
import { cartActions } from "../../storage/cart";
import { modalActions } from "../../storage/modals";
import { useParams } from "react-router-dom";

const MoneyToCart = (props) => {
  let amount = useSelector((state) => state.modals.moneyCart.amount);
  const cart = useSelector((state) => state.cart.goods);
  const [pricelist, setPricelist] = useState({});
  const [done, setDone] = useState(false);
  const dispatch = useDispatch();
  let total =
    (parseFloat(amount) / parseFloat(pricelist.step)) *
    parseFloat(pricelist.price);
  const params = useParams();

  useEffect(() => {
    const getPrice = async () => {
      const response = await fetch(`${api.apiPath}&path=money&server=${params.server}`);

      if (!response.ok) {
        console.log("Error while loading product's data");
        return;
      }

      const payload = await response.json();

      setPricelist(payload);
      setDone(false);
    };

    getPrice();
  }, [amount, params.server]);

  const addToCart = () => {
    const productData = {
      addition: amount,
      category: false,
      icon: "/assets/images/money-icon.png",
      id: 'money',
      name: "Игровая валюта",
      period: amount + " $",
      total: total,
    };

    const search = cart.findIndex((item) => {
      return item.id === "money";
    });

    if (search >= 0) {
      window.alert("Этот товар уже добавлен в корзину!");
    } else {
      dispatch(cartActions.addToCart(productData));
      setDone(true);
    }
  };

  const openCart = () => {
    dispatch(modalActions.hideAllModals());
    dispatch(modalActions.showCartModal());
  };

  return (
    <div className="modal-window modal-window_card-added">
      <div className="modal-controls-wrapper">
        <h5 className="modal-title">
          {done ? "Товар добавлен в корзину!" : "Добавить в корзину"}
        </h5>
        <button
          type="button"
          className="modal-close"
          onClick={props.closeHandler}
        ></button>
      </div>
      <div className="modal-gray">
        <div className="card-add-item">
          <div className="card-add-item__photo">
            <img
              src="/assets/images/money-icon.png"
              alt="Покупка игровой валюты"
            />
          </div>
          <div className="card-add-item__data">
            <div className="card-add-meta-row">
              <div className="card-add-title-row">
                <h5 className="card-add-title">Игровая валюта</h5>
              </div>
              <span className="card-add-price">{total.toFixed(0)} &#8381;</span>
            </div>
            <span className="card-add-period">{amount.toFixed(0)} $</span>
          </div>
        </div>
      </div>
      {done && (
        <>
          <button type="button" className="modal-btn" onClick={openCart}>
            Перейти к оформлению заказа
          </button>
          <button
            type="button"
            className="modal-btn-clear"
            onClick={props.closeHandler}
          >
            Продолжить покупки
          </button>
        </>
      )}
      {!done && (
        <button type="button" className="modal-btn" onClick={addToCart}>
          Добавить товар в корзину
        </button>
      )}
    </div>
  );
};

export default MoneyToCart;
